import { AUTHORIZATION_MODULE_PATH } from '@/store/modules/authorization';

export default (store, func) => {
  let registered = false;
  store.dispatch('boilerplate/addDelayedModule', 'requests');

  store.subscribe((mutation) => {
    if (
      !registered &&
      mutation.type === 'RouteModule/ROUTE_CHANGED' &&
      mutation.payload.to.fullPath === '/requests'
    ) {
      func();
      registered = true;
      store.dispatch('boilerplate/setLoading', null);
      store.dispatch('boilerplate/removeDelayedModule', 'requests');
    }
  });
  store.subscribeAction((action) => {
    if (action.type === `${AUTHORIZATION_MODULE_PATH}/setAuthorizations`) {
      if (
        (!registered && action.payload.isDispatcher) ||
        store.getters['RouteModule/path'] === 'requests'
      ) {
        func();
        registered = true;
        store.dispatch('boilerplate/removeDelayedModule', 'requests');
      }
    }
  });
};
